'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.execClientSideOnly = exports.execServerSideOnly = exports.isServerSide = exports.PageLoader = undefined;

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
	Example:
	-------
	initActions([
		{
			key: 'listings.healthChecksTreatmentGroups',
			action: globalRedux.globaActions.heathChecks,
			arguments: ['healthChecks']
		},
		props,
		store.dispatch
	]);
	Note:
	-----
	This function will only run ONE time.
**/

var PageLoader = exports.PageLoader = function () {
  function PageLoader(loaders) {
    _classCallCheck(this, PageLoader);

    this.isLoaded = false;
    this.loaders = loaders;
  }

  _createClass(PageLoader, [{
    key: 'runOnce',
    value: function runOnce(dispatch, props, xhrConfig) {
      var dynamicArguments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isGooglebotPageHit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (this.isLoaded) {
        return _bluebird2.default.resolve(false);
      } else {
        this.isLoaded = true;
        return _bluebird2.default.all(this.loaders.filter(function (loader) {
          if (loader.loadGooglebotOnly) {
            return isGooglebotPageHit;
          }
          if (loader.loadFrontAndServerSide === true) {
            return true;
          }
          if (loader.loadOnlyFrontEnd && isServerSide()) {
            return false;
          }
          if (loader.loadOnlyServerSide && !isServerSide()) {
            return false;
          }
          var alreadyLoaded = (0, _get3.default)(props, loader.key);
          if (!alreadyLoaded) {
            return true;
          }
          if ((0, _isArray3.default)(alreadyLoaded)) {
            return !alreadyLoaded.length;
          }
          return false;
        }).map(function (el) {
          return el;
        }).map(function (loader) {
          return dispatch(loader.action.apply(loader, _toConsumableArray((loader.arguments || []).map(function (arg) {
            if ((loader.dynamicArguments || []).indexOf(arg) > -1) {
              return dynamicArguments[arg];
            } else {
              return arg;
            }
          }) || []).concat([xhrConfig])));
        }));
      }
    }
  }]);

  return PageLoader;
}();

var isServerSide = exports.isServerSide = function isServerSide() {
  return typeof window === 'undefined';
};

var execServerSideOnly = exports.execServerSideOnly = function execServerSideOnly(func, args) {
  if (isServerSide()) {
    return func.apply(undefined, _toConsumableArray(args));
  }
};

var execClientSideOnly = exports.execClientSideOnly = function execClientSideOnly(func, args) {
  if (!isServerSide()) {
    return func.apply(undefined, _toConsumableArray(args));
  }
};